module.exports = __webpack_public_path__ + "static/media/lowFodmap.2f1cce9f.jpg";